// removed by extract-text-webpack-plugin
module.exports = {"notice_wrap":"notice_wrap___3a7O0","icon_notice":"icon_notice___1KyJB","icon_close":"icon_close___33F9d","notice_content":"notice_content___YWC1X"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/notice/index.less.module
// module id = 548
// module chunks = 1